export enum TranscodeStatus {
  Awaiting = 'Awaiting',
  Complete = 'Complete',
  Processing = 'Processing',
  Error = 'Error',
}
